import { render } from "./pickup-detail-sidebar.vue?vue&type=template&id=7f2e5eec&ts=true"
import script from "./pickup-detail-sidebar.vue?vue&type=script&lang=ts"
export * from "./pickup-detail-sidebar.vue?vue&type=script&lang=ts"

import "./pickup-detail-sidebar.vue?vue&type=style&index=0&id=7f2e5eec&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__